<template>
  <div class="bookmark-btn-show" v-if="!showBookmarks && !isWizardOpen">
      <template v-if="bookMarkTotal > 0">
      <a href="#" @click.prevent="$emit('click', course)"
        ><div class="text-label">{{translationHelper.getTranslation("wbk_BookmarkCounter")}}</div><div class="text-value">&nbsp;({{ bookMarkTotal }})</div><div class="ui-widget ui-icon-bookmark pointer"></div></a
      >
      </template>
      <template v-else>
        <span><div class="text-label">{{translationHelper.getTranslation("wbk_BookmarkCounter")}}</div><div class="text-value">&nbsp;({{ bookMarkTotal }})</div><div class="ui-widget ui-icon-bookmark"></div></span>
      </template>
    </div>
</template>

<script>
export default {
props: [ "showBookmarks", "isWizardOpen", "bookMarkTotal" ,"translationHelper"]

}
</script>
